import { Inject, Injectable, Injector, Renderer2, RendererFactory2 } from '@angular/core';
import { LocalStorageHelper } from '../../shared/helper/local-storage-helper';
import { BredaColorConstants, CssThemes, IconsConstants, ModdakirColorConstants, ModdakirKidsConstants, RattelColorConstants, SharedConstants, TaalamColorConstants, TebyanColorConstants, TeganColorConstants, ThemeColors } from '../../shared/common';
import { DOCUMENT } from '@angular/common';
import { Icon, ImageIcon } from '../../shared/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemesService {
  defaultTheme: CssThemes = CssThemes.MODDAKIR;
  currentTheme: CssThemes;
  currentThemeColors: ThemeColors;
  logo: ImageIcon;
  changeLogo$: Observable<Icon>;
  changeTheme$: Observable<ThemeColors>;
  private changeTheme: BehaviorSubject<ThemeColors> = new BehaviorSubject(null);
  private changeLogo: BehaviorSubject<Icon> = new BehaviorSubject(null);
  
  constructor(private injector: Injector, @Inject(DOCUMENT) private document: Document) {
    this.changeLogo$ = this.changeLogo.asObservable();
    this.changeTheme$ = this.changeTheme.asObservable();
    //this.getTheme();
  }

  setTheme(theme: CssThemes): void {
    const renderer2: Renderer2 = this.injector.get(RendererFactory2).createRenderer(null, null);
    this.removeTheme(renderer2);
    const styleLink: HTMLLinkElement = renderer2.createElement('link');
    renderer2.setProperty(styleLink, 'rel', 'stylesheet');
    renderer2.setProperty(styleLink, 'type', 'text/css');
    renderer2.setProperty(styleLink, 'href', `${theme == CssThemes.SUPER_ADMIN ? this.defaultTheme : theme}.css`);
    renderer2.setProperty(styleLink, 'id', theme == CssThemes.SUPER_ADMIN ? this.defaultTheme : theme);
    renderer2.appendChild(this.document.head, styleLink);
    this.currentTheme = theme;
    LocalStorageHelper.setItem(SharedConstants.LOCAL_STORAGE_THEME_KEY, this.currentTheme);
    this.setCurrentThemeColors();
  }

  //privates
  getTheme(): void {
    const theme = LocalStorageHelper.getItem(SharedConstants.LOCAL_STORAGE_THEME_KEY);
    if (theme && Object.values(CssThemes).includes(theme)) {
      this.currentTheme = theme;
      this.setTheme(theme);
    } else {
      this.setTheme(this.defaultTheme);
    }
  }

  private removeTheme(renderer2: Renderer2) {
    const existingTheme = this.document.getElementById(this.currentTheme);
    if (existingTheme) {
      renderer2.removeChild(this.document.head, existingTheme);
    }
  }

  private setCurrentThemeColors(): void {
    switch(this.currentTheme) {
      case CssThemes.MODDAKIR:
        this.currentThemeColors = new ModdakirColorConstants();
        this.logo = IconsConstants.MODDAKIR_LOGO_ICON
        break;
      case CssThemes.WL2:
        this.currentThemeColors = new TaalamColorConstants();
        this.logo = IconsConstants.TAALAM_ICON
        break;
      case CssThemes.WL3:
        this.currentThemeColors = new RattelColorConstants();
        this.logo = IconsConstants.RATTEL_ICON;
        break;
      case CssThemes.WL5:
        this.currentThemeColors = new TeganColorConstants();
        this.logo = IconsConstants.TEGAN_ICON;
        break;
      case CssThemes.WL6:
        this.currentThemeColors = new TebyanColorConstants();
        this.logo = IconsConstants.TEBYAN_LOGO_ICON;
        break;
      case CssThemes.BREDA:
        this.currentThemeColors = new BredaColorConstants();
        this.logo = IconsConstants.BREDA_ICON;
        break;
      case CssThemes.SUPER_ADMIN:
        this.currentThemeColors = new ModdakirColorConstants();
        this.logo = IconsConstants.MODDAKIR_LOGO_ICON
        break;
      case CssThemes.MODDAKIR_KIDS:
        this.currentThemeColors = new ModdakirKidsConstants();
        this.logo = IconsConstants.MODDAKIR_KIDS_LOGO_ICON;
        break;
    }
    this.changeLogo.next(this.logo);
    this.changeTheme.next(this.currentThemeColors);
  }
}

export function ApplicationThemeFactory(injector: Injector): () => Promise<void> {
  return () => ApplicationThemeContainer(injector);
}

async function ApplicationThemeContainer(injector: Injector): Promise<void> {
  return initializeTheme(injector);
}

// initalize theme and preload it
async function initializeTheme(injector: Injector): Promise<void> {
  try {
    await injector.get(ThemesService).getTheme();
  } catch (error) {
    console.log(error);
  }
}
